module.exports = __webpack_public_path__ + "static/media/34.d4edf1c7.jpg";